import {styledByTheme} from "../../themes/architecture/styled-by-theme";
import {LayoutWrapperDefaultBox} from "./layout-wrapper.default.box";
import {LayoutWrapperWsopBox} from "./layout-wrapper.wsop.box";

export const LayoutWrapperBox = styledByTheme(LayoutWrapperDefaultBox)
    .forWsop(LayoutWrapperWsopBox)
    .apply();
